export const SERVER_URL = REACT_APP_SERVER_URL;
